"use client";

import FilterAltOffRounded from "@mui/icons-material/FilterAltOffRounded";
import Button from "@mui/material/Button";

export type FilterResetButtonProps = {
  label: string;
  onClick: () => void;
  /**
   * `true` quand aucun filtre n'est actif. Le bouton reste alors visible mais
   * inerte : le faire disparaître déplacerait tout ce qui l'entoure au premier
   * filtre coché.
   */
  disabled?: boolean;
  /**
   * `block` — seul en tête d'une colonne de filtres, calé à gauche.
   * `inline` — dernier élément d'une rangée de champs, sans se laisser
   * comprimer par eux.
   */
  layout?: "block" | "inline";
  "data-testid"?: string;
};

/**
 * Bouton « Réinitialiser les filtres ».
 *
 * En `text` et en `text.secondary` : c'est une sortie de secours, pas l'action
 * que la page propose. L'icône est un entonnoir barré — les trois copies
 * remplacées montraient un entonnoir simple, le même que le bouton qui *ouvre*
 * les filtres sur mobile.
 */
export function FilterResetButton({
  label,
  onClick,
  disabled = false,
  layout = "block",
  "data-testid": dataTestId,
}: FilterResetButtonProps) {
  return (
    <Button
      variant="text"
      size="small"
      onClick={onClick}
      disabled={disabled}
      startIcon={<FilterAltOffRounded fontSize="small" />}
      data-testid={dataTestId}
      sx={{
        color: "text.secondary",
        ...(layout === "block"
          ? { alignSelf: "flex-start" }
          : { flexShrink: 0 }),
      }}
    >
      {label}
    </Button>
  );
}
